import { create } from 'zustand';

import { KeyImagePollingState } from './use-key-image-polling.model';

export const useKeyImagePollingStore = create<KeyImagePollingState>((set) => ({
  hasRetrievalError: false,
  hasStartedPolling: false,
  isRetrievingKeyImages: false,

  setHasRetrievalError: (hasRetrievalError: boolean) => set({ hasRetrievalError }),
  setHasStartedPolling: (hasStartedPolling: boolean) => set({ hasStartedPolling }),
  setIsRetrievingKeyImages: (isRetrievingKeyImages: boolean) => set({ isRetrievingKeyImages }),
}));
